import * as Actions from './actions'

export default {
  namespaced: true,
  state: {
    zones: [],
    areas: [],
    parkings: [],
  },
  getters: {
    GetAreaById: (state) => (areaId) => {
      return state.areas.find(i => i.id.toString() === areaId)
    }
  },
  mutations: {},
  actions: {
    ...Actions
  }
}